import { render, staticRenderFns } from "./TourPortrayal.vue?vue&type=template&id=5a8cd13a&scoped=true&"
import script from "./TourPortrayal.vue?vue&type=script&lang=js&"
export * from "./TourPortrayal.vue?vue&type=script&lang=js&"
import style0 from "./TourPortrayal.vue?vue&type=style&index=0&id=5a8cd13a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8cd13a",
  null
  
)

export default component.exports